<template>
  <div class="portal-products">

    <div class="portal-product" v-for="(item, index) in items" :key="index">
      <h3 v-if="item.product.name !== 'SSRI medication (Your psychiatrist will determine which medication may be right for you)'">Your Cart</h3>
      <div
        class="portal-product-image"
        :class="{ 'no--paddings': isDerma(item) }"
      >
        <img
          v-if="isDerma(item)"
          :style="{ objectFit: isDerma(item) ? 'contain' : '' }"
          :src="isDerma(item) ? item.product.thumbnail : getImageUrl(item.product.thumbnail)"
          :alt="item.product.name"
        >
        <img
          v-else
          :src="item.product.thumbnail"
          :alt="item.product.name"
        >
      </div>
      <div
        class="portal-product-video"
        v-if="isDerma(item)"
      >
        <video width="100%" muted autoplay loop>
          <source :src="`/video/${getVideoUrl(item.product.thumbnail)}`" type="video/mp4">
          Your browser does not support HTML video.
        </video>
      </div>
      <div class="portal-product-info--wrapper">
        <div class="portal-product-info">
                  <span class="portal-product-text">
                      {{ item.product.fullName }},
                      <template v-if="item.product.category && item.product.category.slug === 'hormones'">{{ item.product.quantity }} month supply</template>
                      <template v-else>{{ item.product.quantity }}</template>
                    <!--<template v-if="item.product.prescriptionOnly">, Rx only</template> ({{ item.product.info }})-->
                  </span>
          <span><span v-if="getDisplayPriceForItem(item) != getOriginalPriceForItem(item)"><s>{{ getOriginalPriceForItem(item)|currency }}</s><br /></span>{{ getDisplayPriceForItem(item)|currency }}</span>
        </div>

        <a v-if="productTitle !== 'SSRI medication (Your psychiatrist will determine which medication may be right for you)'" class="cart-action--light" :href="`/cart/items/${item.rowId}`">
          <span class="remove"></span>
          Remove {{ item.name }} {{ item.product.strength }}, <template v-if="item.product.category && item.product.category.slug === 'hormones'">{{ item.product.quantity }} month supply</template><template v-else>{{ item.product.quantity }}</template>
        </a>
      </div><!-- .portal-product-info--wrapper -->
    </div><!-- .portal-product -->
    <span class="portal-product-text"><small>24 Hour Shipping (always included)</small></span>
    <template v-if="couponCode">
      <div class="portal-product-info portal-product-info--sub">
        <span class="portal-product-text">Subtotal:</span>
        <span class="portal-product-text">{{ subtotal|currency }}</span>
      </div>
      <div class="portal-product-info portal-product-info--sub">
        <span class="portal-product-text">Discount/Voucher Code:</span>
        <span class="portal-product-text">{{ couponCode }}</span>
      </div>
      <div class="portal-product-info portal-product-info--final">
        <span class="portal-product-text">Total: <span class="note" v-if="firstShipmentNote">{{ firstShipmentNote }}</span></span>
        <span class="portal-product-text">{{ firstShipmentTotal|currency }}</span>
      </div>
      <p v-if="productCategory === 'Mental health'"> You are only charged for the 3-month supply of medication if the Board-Certified psychiatrist who reviews your consult prescribes you medication.  The $90 charge includes 3 month of medication, and 24 Hour Shipping - there are no other charges! This is the lowest price of any US telehealth company!</p>
    </template>
    <template v-else>
      <div class="portal-product-info portal-product-info--final">
        <span class="portal-product-text">Total:</span>
        <span class="portal-product-text">{{ subtotal|currency }}</span>
      </div>
      <p v-if="productCategory === 'Mental health'">You are only charged for the 3-month supply of medication if the Board-Certified psychiatrist who reviews your consult prescribes you medication.  The $90 charge includes 3 month of medication, and 24 Hour Shipping - there are no other charges! This is the lowest price of any US telehealth company!</p>
    </template>
  </div><!-- portal-products -->
</template>
<script>
import { EventBus } from './event-bus.js';
import axios from 'axios';
export default {
  props: {
    // items: {},
    initialCouponCode: {},
    unlimitedCouponCode: {
      type: Boolean
    }
  },
  data() {
    return {
      couponCode: null,
      cart: null,
      isLoadingCart: false,
      trtPlanTotal: null,
      trtPlanProductId: null,
    }
  },
  filters: {
    currency(value) {
      return '$'+parseFloat(value).toFixed(2);
    }
  },
  watch: {
  },
  computed: {
    getVideoUrl() {
      return (url) => {
        let vidUrl = url.split('/images/thumbnails/').join('')
        vidUrl = vidUrl.split('.jpg').join('.mp4')
        return vidUrl
      }
    },
    getImageUrl() {
      return (url) => {
        let imageUrl = url.split('.jpg').join('.png')
        return imageUrl
      }
    },
    items() {
      return this.cart ? this.cart.items : []
    },
    productCategory() {
      let productCategory = '';
      this.items.forEach((item) => {
        productCategory = this.getCategoryForItem(item)
      });
      return productCategory;
    },
    productTitle() {
      let productTitle = '';
      this.items.forEach((item) => {
        productTitle = this.getProductTitleForItem(item)
      });
      return productTitle;
    },
    subtotal() {
      let subtotal = 0;
      this.items.forEach((item) => {
        subtotal += this.getPriceForItem(item)
      });
      return subtotal;
    },
    firstShipmentTotal() {
      let subtotal = 0;
      this.items.forEach((item) => {
        subtotal += this.getFirstShipmentPriceForItem(item)
      });
      return subtotal;
    },
    firstShipmentNote() {
      if (this.firstShipmentTotal === 0) {
        if (this.unlimitedCouponCode) {
          return '(First shipment is FREE!)'
        }
        return '(First shipment is pre-paid)'
      }
      return ''
    },
    cartQueryString() {
      if (this.couponCode) {
        return `?couponCode=${this.couponCode}`
      }
      return ''
    }
  },
  mounted() {
    if (this.initialCouponCode) {
      this.couponCode = this.initialCouponCode;
    }
    EventBus.$on('validatedCode', couponCode => {
      this.couponCode = couponCode;
      this.retrieveCurrentOrder()
    });
    EventBus.$on('removedCode', () => {
      this.couponCode = null;
      this.retrieveCurrentOrder()
    });
    EventBus.$on('trtPlanChanged', payload => {
      this.trtPlanTotal = payload ? payload.total : null;
      this.trtPlanProductId = payload ? payload.productId : null;
    });
    EventBus.$emit('trtPlanRequest');
    this.retrieveCurrentOrder();
  },
  methods: {
    isTrtPlanItem(item) {
      return item && item.product && this.trtPlanProductId && item.product.id === this.trtPlanProductId;
    },
    isDerma(item) {
      return item.product.id === '642edd7e-d3cf-4a7a-9e9a-db683a7a0b39' ||
        item.product.id === '009cad7b-08a1-4de9-afbc-b30f7c824d7d' ||
        item.product.id === 'b16fa3da-48ad-470e-8d9c-4f592a2b5765' ||
        item.product.id === '74536e54-1207-45b6-a889-3c1776787ef7' ||
        item.product.id === 'a3fb0ef6-0225-4b1b-ac0f-2b25576e8419'
    },
    getPriceForItem(item) {
      if (this.trtPlanTotal !== null && this.isTrtPlanItem(item)) {
        return this.trtPlanTotal;
      }
      return item.price;
    },
    // The pre-discount price to show struck through. For a plan-billed TRT item the
    // "real" price is the whole plan ($198/$534/$948), not the $79 catalogue price —
    // striking $79 next to $948 read as though $79 were the original.
    getOriginalPriceForItem(item) {
      if (this.trtPlanTotal !== null && this.isTrtPlanItem(item)) {
        return this.trtPlanTotal;
      }
      return item.product.price;
    },
    getCategoryForItem(item) {
      return item.product.category.title;
    },
    getProductTitleForItem(item) {
      return item.product.name;
    },
    getFirstShipmentPriceForItem(item) {
      const serverFirstShipmentPrice = item.firstShipmentPrice !== null && item.firstShipmentPrice !== undefined
        ? item.firstShipmentPrice
        : item.price;

      // A coupon campaign is already priced server-side into firstShipmentPrice
      // (Cart::getFirstShipmentPriceForProduct), so it has to win over the locally
      // selected TRT plan total — otherwise the plan price keeps showing and the
      // cart claims the patient owes the full plan price while the server charges
      // the discount.
      if (this.couponCode) {
        return serverFirstShipmentPrice;
      }

      if (this.trtPlanTotal !== null && this.isTrtPlanItem(item)) {
        return this.trtPlanTotal;
      }

      return serverFirstShipmentPrice;
    },
    getDisplayPriceForItem(item) {
      if (this.couponCode) {
        return this.getFirstShipmentPriceForItem(item);
      }
      return this.getPriceForItem(item);
    },
    retrieveCurrentOrder() {
      if (this.isLoadingCart) {
        return;
      }

      this.isLoadingCart = true;

      axios.get(`/api/v1/cart${this.cartQueryString}`)
        .then((response) => {
          if (response.data.data) {
            this.cart = response.data.data
          }
        })
        .catch(function (error) {
        })
        .finally(() => {
          this.isLoadingCart = false;
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/Products.vue